import { render, staticRenderFns } from "./ChatbotProposalHandleModal.vue?vue&type=template&id=220e52e4&scoped=true"
import script from "./ChatbotProposalHandleModal.vue?vue&type=script&lang=js"
export * from "./ChatbotProposalHandleModal.vue?vue&type=script&lang=js"
import style0 from "./ChatbotProposalHandleModal.vue?vue&type=style&index=0&id=220e52e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e52e4",
  null
  
)

export default component.exports